import {ReactElement, Children, Fragment, useEffect, useState} from "react";

interface Props {
    children: ReactElement|undefined|null|false|((ReactElement|null|undefined|false)[]),
    className?: string
}


export function FiltersCluster({children, className}:Props) {
    let sublist:ReactElement[] = [];
    const list:ReactElement[][] = [sublist];
    const [width, setWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth)
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])


    let count = 0;
    const max = width > 900 ? 4 : width > 600 ? 2 : 1;
    let maxIndex = 0;
    Children.forEach(children,(f, index) => {
        if(!f) {
            return;
        }
        if(count === max) {
            count = 0;
            sublist = [];
            list.push(sublist);
        }
        count++;
        maxIndex = index;
        sublist.push(<Fragment key={index}>{f}</Fragment>);
    });
    while(sublist.length < max) {
        maxIndex++;
        sublist.push(<div key={maxIndex}/>)
    }

    return <div className={className}>{list.map((sub, index) => {
        return <div className="filter-row" key={index}>{sub}</div>
    })}</div>;
}